var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96092 6C5.96092 6.52214 6.16834 7.0229 6.53755 7.39212C6.90676 7.76133 7.40752 7.96875 7.92967 7.96875C8.45181 7.96875 8.95257 7.76133 9.32178 7.39212C9.691 7.0229 9.89842 6.52214 9.89842 6C9.89842 5.47786 9.691 4.9771 9.32178 4.60788C8.95257 4.23867 8.45181 4.03125 7.92967 4.03125C7.40752 4.03125 6.90676 4.23867 6.53755 4.60788C6.16834 4.9771 5.96092 5.47786 5.96092 6V6ZM15.5621 5.54648C13.8957 2.03613 11.3767 0.269531 7.99998 0.269531C4.62146 0.269531 2.10428 2.03613 0.43787 5.54824C0.37103 5.68978 0.336365 5.84436 0.336365 6.00088C0.336365 6.1574 0.37103 6.31198 0.43787 6.45352C2.10428 9.96387 4.62322 11.7305 7.99998 11.7305C11.3785 11.7305 13.8957 9.96387 15.5621 6.45176C15.6974 6.16699 15.6974 5.83652 15.5621 5.54648V5.54648ZM7.92967 9.09375C6.22107 9.09375 4.83592 7.70859 4.83592 6C4.83592 4.29141 6.22107 2.90625 7.92967 2.90625C9.63826 2.90625 11.0234 4.29141 11.0234 6C11.0234 7.70859 9.63826 9.09375 7.92967 9.09375Z",
    fill: "#BBBEC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eyeOpen.8a0e939fd8b1aac5ded8a6b8481a4756.svg";
export { ForwardRef as ReactComponent };